import * as React from 'react';
const TrendsRegExp = new RegExp(`(.*)((?:letzten|last)\\s[0-9]+(?:\\s(?:von|of)+\\s[0-9]+)?\\s(?:Spielen?|Heimspielen?|Ausw�rtsspielen?|matches|home matches|away matches)+)(.*)`);
const Trend = ({ trend }) => {
    const regexp = trend.match(TrendsRegExp);
    if (regexp && regexp.length > 3) {
        return (React.createElement("span", null,
            regexp[1],
            React.createElement("b", null, regexp[2]),
            regexp[3]));
    }
    else {
        // Fallback trend without formatting
        return React.createElement("span", null, trend);
    }
};
export default Trend;
//# sourceMappingURL=Trend.js.map